import { z } from 'zod';

const MAX_FILE_SIZE = 1024 * 1024 * 10; // 10 MB
const ACCEPTED_FILE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
const DEFAULT_FILE_ERROR_MESSAGE = 'Selecione uma imagem jpg, jpeg ou png';

export const formSchema = z.object({
  eventId: z.number(),
  justification: z.string()
    .min(1, 'A justificativa é obrigatória')
    .max(200, 'Descreva sua justificativa com no máximo 200 caracteres'),
  file: z.instanceof(FileList),
}).superRefine((formData, ctx) => {
  const { file: fileList } = formData;

  const file = fileList[0];

  if (file && !ACCEPTED_FILE_TYPES.includes(file.type)) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: DEFAULT_FILE_ERROR_MESSAGE,
      path: ['file'],
    });
  }

  if (file && file.size > MAX_FILE_SIZE) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Arquivo não pode exceder 10 MB',
      path: ['file'],
    });
  }
});

export type FormSchema = z.infer<typeof formSchema>;